import {
  ApiRequestError,
  parseJsonOrThrow,
  throwFromErrorBody,
  type ValidationFieldError,
} from "../utils/apiRequestError";

/** Re-throw ApiRequestError as a domain-specific API error class. */
export function mapApiRequestError<T extends Error>(
  err: unknown,
  map: (message: string, status: number, parsed: ApiRequestError) => T
): never {
  if (err instanceof ApiRequestError) {
    throw map(err.message, err.status, err);
  }
  throw err;
}

export async function parseServiceJsonOrThrow<T>(
  response: Response,
  fallbackMessage: string,
  mapError: (message: string, status: number, parsed: ApiRequestError) => Error,
  options?: { allow204?: boolean }
): Promise<T> {
  try {
    return await parseJsonOrThrow<T>(response, fallbackMessage, options);
  } catch (err) {
    mapApiRequestError(err, mapError);
  }
}

export { throwFromErrorBody, type ValidationFieldError };
